import React, { memo } from "react";
import { RotaItemProps } from "../interfaces/Dropdown.interfaces";
import StyledRota from "./DropdownStyledRotaItem.tsx";

function RotaItem({ item, onClick }: RotaItemProps) {
	return (
		<div className="botao-menu-cte" onClick={onClick}>
			<StyledRota to={item.rota}>
				<span className="botao-menu">{item.label}</span>
			</StyledRota>
		</div>
	);
}

export default memo(RotaItem);
